import EditorAbstractField from "./EditorAbstractField.mjs";
import {Input, InputGroup, InputGroupText, Label} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import EditorSubUnits from "./EditorSubUnits.mjs";

const EditorUnitValue = class extends  EditorAbstractField {
	constructor(props) {
		super(props);
		this.UnitValueSetMinMax = this.UnitValueSetMinMax.bind(this);
	}
	async UnitValueSetMinMax( evt ) {
		const prop = evt.target.name;
		let v = evt.target.value;
		v = v ? parseFloat(v) : undefined;
		const v2 = (this.state.value || {})[prop === 'min' ? 'max' : 'min'];
		const cantSlide = (typeof v === "undefined" || typeof v2 === 'undefined' );
		if ( cantSlide && this.state.value.slider ) await this.setValue( 'slider' );
		await this.setValue( prop, v );
	}
	field() {
		const cantSlide =  typeof this.state.value?.min === 'undefined' || typeof this.state.value?.max === 'undefined';
		return(
			<>
				{this.textareaField()}
				<InputGroup>
					<InputGroupText>
						<TextLabel value={"Min"}/>
					</InputGroupText>
					<Input
						name={"min"}
						bsSize={"sm"}
						type={"number"}
						placeholder={"—"}
						value={this.state.value?.min ?? ''}
						onChange={this.UnitValueSetMinMax}
					/>
					<InputGroupText>
						<TextLabel value={"Max"}/>:
					</InputGroupText>
					<Input
						name={"max"}
						bsSize={"sm"}
						type={"number"}
						placeholder={"—"}
						value={this.state.value?.max ?? ''}
						onChange={this.UnitValueSetMinMax}
					/>
					<InputGroupText
						hidden={cantSlide}
					>
						<Input
							id={this.uid + '-UnitValue-slider'}
							type={"checkbox"}
							checked={!!this.state.value?.slider}
							onChange={e => {
								this.setValue('slider', e.target.checked || undefined);
							}}
						/>
					</InputGroupText>
					<InputGroupText
						hidden={cantSlide}
					>
						<Label htmlFor={this.uid + '-UnitValue-slider'}>
							<TextLabel value={"View as slider"}/>
						</Label>
					</InputGroupText>
				</InputGroup>
				<div className={"fieldRow RadioField"}>
					<Label>
						<TextLabel value={"Units"}/>
					</Label>
					<EditorSubUnits
						key={this.state.changes}
						units={this.state.value?.units}
						setValue={o => this.setValue('units', o)}
					/>
				</div>
			</>
		)
	}
}

export default EditorUnitValue;